<div fxLayout=row fxLayoutAlign="space-around center">
  <mat-card style="width: 100%">
    <mat-card-title>
        <h3 i18n>Time Report</h3>
    </mat-card-title>

    <timereport-add [sentDates]="sentDates" [timereport]=timereport></timereport-add>
    <br /><br />
    <timereport-list [sentDates]="sentDates"></timereport-list>              
  </mat-card>
</div>






// WEBPACK FOOTER //
// ./src/app/timereport/timereport.component.html